
function SetHover () 
{
	var sfEls = document.getElementById("nav").getElementsByTagName("LI");
	for (var i=0; i<sfEls.length; i++) 
	{
		sfEls[i].onmouseover=function() 
		{
			this.className+=" sfhover";
		}
		sfEls[i].onmouseout=function() 
		{
			this.className=this.className.replace(new RegExp("( )?sfhover\\b"), "");
		}
	}

	if (document.getElementById("float"))
	{
		sfEls = document.getElementById("float").getElementsByTagName("LI");
		for (var i=0; i<sfEls.length; i++) 
		{
			sfEls[i].onmouseover=function() 
			{
				this.className+=" sfhover";
			}
			sfEls[i].onmouseout=function() 
			{
				this.className=this.className.replace(new RegExp("( )?sfhover\\b"), "");
			}
		}
	}
}

function submitSearch()
{
	window.location.href = "FreeTextSearch.php?NewSearch=true&SearchOnlyCurrentWorkflow=false&SearchText=" + encodeURIComponent($('#searchField').val());
}

$(document).ready(function()
{
	if ($('#masthead').length > 0)
	{
		$(".button_sm").button();
		$(".search_hover").hover(function()
		{		
			$(this).addClass('search_hover_highlighter');
		},
		function()
		{
			$(this).removeClass('search_hover_highlighter');
		});
		var timer = 0;
		$('#dropdown_box').mouseleave(function() {$(this).toggle();});
		$('#searchField').watermark('Search');
	}
});

